import React from 'react';
import { HANDOFF } from '../../data/spine';

// The hand-off between the two product pages: the same two sentences on
// /platform#app-kit and /app-kit, so a visitor on either page sees how the
// other relates. `here` marks the page being read; the CTA row is the
// caller's (the links differ by page).
export default function ProductHandoff({ here, children }) {
  const cards = [['platform', HANDOFF.platform], ['kit', HANDOFF.kit]];
  return (
    <div className="cs-sw-card cs-handoff">
      <p className="cs-handoff-line">{HANDOFF.line}</p>
      <div className="cs-handoff-grid">
        {cards.map(([id, c]) => (
          <div key={id} className={`cs-handoff-card${here === id ? ' is-here' : ''}`}>
            <h3>{c.k}{here === id && <span>this page</span>}</h3>
            <p>{c.v}</p>
          </div>
        ))}
      </div>
      {children && <div className="cs-land-cta-row">{children}</div>}
    </div>
  );
}
